import React from "react";
import { Phone, Search, Bookmark, Settings2, BarChart3 } from "lucide-react";

export default function Header({ view, setView, onSettings }) {
  return (
    <header className="sticky top-0 z-30 bg-white border-b border-border">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-brand-600 text-white flex items-center justify-center font-display font-bold text-[17px]">
            G
          </div>
          <div>
            <div className="font-display font-bold text-[17px] text-foreground leading-none">Geokath</div>
            <div className="text-[11px] text-muted-foreground">Lead Finder</div>
          </div>
        </div>

        <nav className="flex items-center gap-1">
          <button
            onClick={() => setView("find")}
            className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-[14px] font-medium transition-colors ${
              view === "find" ? "bg-brand-50 text-brand-700" : "text-muted-foreground hover:bg-secondary"
            }`}
          >
            <Search size={16} /> Find Leads
          </button>
          <button
            onClick={() => setView("lists")}
            className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-[14px] font-medium transition-colors ${
              view === "lists" ? "bg-brand-50 text-brand-700" : "text-muted-foreground hover:bg-secondary"
            }`}
          >
            <Bookmark size={16} /> Saved Lists
          </button>
          <button
            onClick={() => setView("digest")}
            className={`flex items-center gap-1.5 px-3.5 py-2 rounded-lg text-[14px] font-medium transition-colors ${
              view === "digest" ? "bg-brand-50 text-brand-700" : "text-muted-foreground hover:bg-secondary"
            }`}
          >
            <BarChart3 size={16} /> Digest
          </button>
        </nav>

        <a
          href="tel:916-572-6998"
          className="hidden sm:flex items-center gap-1.5 text-[14px] font-medium text-foreground hover:text-brand-600"
        >
          <Phone size={15} /> (916) 572-6998
        </a>
        <button
          onClick={onSettings}
          title="Instantly field mapping"
          className="ml-3 hidden sm:inline-flex items-center justify-center w-9 h-9 rounded-lg text-muted-foreground hover:bg-secondary hover:text-foreground transition-colors"
        >
          <Settings2 size={18} />
        </button>
      </div>
    </header>
  );
}
